module.exports = __webpack_public_path__ + "img/ybatmaz.579b85cb.png";